/**
 * @generated SignedSource<<5191543bd2470d316ddeeede4a6d883b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetFeatureFlagAlwaysLastInput = {
  companyId?: string | null;
  alwaysLast?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type setFeatureFlagAlwaysLastMutation$variables = {
  input: SetFeatureFlagAlwaysLastInput;
};
export type setFeatureFlagAlwaysLastMutation$data = {
  readonly SetFeatureFlagAlwaysLast: {
    readonly missionControlData: {
      readonly id: string;
      readonly featureFlagLists: {
        readonly id: string;
        readonly cohorts: ReadonlyArray<{
          readonly id: string;
          readonly cohortId: number | null;
          readonly name: string | null;
          readonly companyIds: ReadonlyArray<number | null> | null;
        } | null> | null;
        readonly alwaysLastCompanyIds: ReadonlyArray<number | null> | null;
      } | null;
    } | null;
  } | null;
};
export type setFeatureFlagAlwaysLastMutation = {
  variables: setFeatureFlagAlwaysLastMutation$variables;
  response: setFeatureFlagAlwaysLastMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetFeatureFlagAlwaysLastPayload",
    "kind": "LinkedField",
    "name": "SetFeatureFlagAlwaysLast",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlDataType",
        "kind": "LinkedField",
        "name": "missionControlData",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlFeatureFlagListsType",
            "kind": "LinkedField",
            "name": "featureFlagLists",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MissionControlFeatureFlagCohortType",
                "kind": "LinkedField",
                "name": "cohorts",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cohortId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyIds",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alwaysLastCompanyIds",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setFeatureFlagAlwaysLastMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setFeatureFlagAlwaysLastMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5784895a5d8362fa69f77628dece5894",
    "id": null,
    "metadata": {},
    "name": "setFeatureFlagAlwaysLastMutation",
    "operationKind": "mutation",
    "text": "mutation setFeatureFlagAlwaysLastMutation(\n  $input: SetFeatureFlagAlwaysLastInput!\n) {\n  SetFeatureFlagAlwaysLast(input: $input) {\n    missionControlData {\n      id\n      featureFlagLists {\n        id\n        cohorts {\n          id\n          cohortId\n          name\n          companyIds\n        }\n        alwaysLastCompanyIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7d9a76e301c8adc8f3f46dc970f1922b";

export default node;
